/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
*/
import React from 'react';
import { connect } from 'react-redux';
export var Include = function Include(_ref) {
  var AppContent = _ref.AppContent;
  return AppContent ? /*#__PURE__*/React.createElement(AppContent, null) : null;
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var data = _ref2.data;

  var _ref3 = data || {},
      _ref3$component = _ref3.component;

  _ref3$component = _ref3$component === void 0 ? {} : _ref3$component;
  var _ref3$component$conte = _ref3$component.content;
  _ref3$component$conte = _ref3$component$conte === void 0 ? {} : _ref3$component$conte;
  var reference = _ref3$component$conte.reference;
  return {
    AppContent: state.digitalCore.wfCms.getIn(['includeComponents', reference])
  };
};

export default connect(mapStateToProps)(Include);